export enum VehicleTypeValidationStatusEnum {
  ACCEPTED = 'ACCEPTED',
  NOT_ACCEPTED = 'NOT_ACCEPTED',
  MANUAL_FILL_REQUIRED = 'MANUAL_FILL_REQUIRED',
}

interface VehicleTypeValidation {
  status: VehicleTypeValidationStatusEnum;
  vehicle_type: string | null;
  vehicle_type_code: string | null;
  message: string | null;
}

export default VehicleTypeValidation;
